/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_RegisteredInputs */

const en_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're registered`)
};

const es_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estás registrado`)
};

const de_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie sind angemeldet`)
};

const zh_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你已报名`)
};

const ar_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنت مسجّل`)
};

const fr_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous êtes inscrit`)
};

const vi_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn đã đăng ký`)
};

const sw_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umesajiliwa`)
};

const th_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณลงทะเบียนแล้ว`)
};

const bs_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijavljeni ste`)
};

const ja_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録済み`)
};

const ko_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등록 완료`)
};

const pt_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você está inscrito`)
};

const it_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei registrato`)
};

const sv_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du är anmäld`)
};

const nl_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bent ingeschreven`)
};

const da_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er tilmeldt`)
};

const nb_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er påmeldt`)
};

const fi_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olet ilmoittautunut`)
};

const pl_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jesteś zarejestrowany`)
};

const ru_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы зарегистрированы`)
};

const tr_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydınız tamamlandı`)
};

const hi_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप पंजीकृत हैं`)
};

const id_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda sudah terdaftar`)
};

const ms_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda sudah berdaftar`)
};

const cs_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jste zaregistrováni`)
};

const el_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Είστε εγγεγραμμένοι`)
};

const he_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אתם רשומים`)
};

const af_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jy is geregistreer`)
};

const hu_events_registered = /** @type {(inputs: Events_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regisztráltál`)
};

/**
* | output |
* | --- |
* | "You're registered" |
*
* @param {Events_RegisteredInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_registered = /** @type {((inputs?: Events_RegisteredInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_RegisteredInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_registered(inputs)
	if (locale === "de") return de_events_registered(inputs)
	if (locale === "zh") return zh_events_registered(inputs)
	if (locale === "ar") return ar_events_registered(inputs)
	if (locale === "fr") return fr_events_registered(inputs)
	if (locale === "vi") return vi_events_registered(inputs)
	if (locale === "sw") return sw_events_registered(inputs)
	if (locale === "th") return th_events_registered(inputs)
	if (locale === "bs") return bs_events_registered(inputs)
	if (locale === "ja") return ja_events_registered(inputs)
	if (locale === "ko") return ko_events_registered(inputs)
	if (locale === "pt") return pt_events_registered(inputs)
	if (locale === "it") return it_events_registered(inputs)
	if (locale === "sv") return sv_events_registered(inputs)
	if (locale === "nl") return nl_events_registered(inputs)
	if (locale === "da") return da_events_registered(inputs)
	if (locale === "nb") return nb_events_registered(inputs)
	if (locale === "fi") return fi_events_registered(inputs)
	if (locale === "pl") return pl_events_registered(inputs)
	if (locale === "ru") return ru_events_registered(inputs)
	if (locale === "tr") return tr_events_registered(inputs)
	if (locale === "hi") return hi_events_registered(inputs)
	if (locale === "id") return id_events_registered(inputs)
	if (locale === "ms") return ms_events_registered(inputs)
	if (locale === "cs") return cs_events_registered(inputs)
	if (locale === "el") return el_events_registered(inputs)
	if (locale === "he") return he_events_registered(inputs)
	if (locale === "af") return af_events_registered(inputs)
	if (locale === "hu") return hu_events_registered(inputs)
	return en_events_registered(inputs)
});